<template>
  <div class="content">
    <div class="content_banner">
      <img src="../../assets/img/banner/zy_banner02.jpg" alt="">
    </div>
    <div class="container_wrap">
      <div class="content_tit">
        <h2>{{data.name}}</h2>
        <div class="content_tit_sub">
          <!-- <span>来源：{{data.source}}</span> -->
          <span>分类：服务领域</span>
          <span>发布时间：{{dayjs(data.updateTime).format('YYYY-MM-DD')}}</span>
          <!-- <span>浏览：{{data.views}}</span> -->
        </div>
        <div class="content_tit_line"></div>
      </div>

      <div class="content_wrap ql-editor" v-html="data.info">
      </div>

    </div>
    
  </div>
</template>

<script>
export default {
  name: 'aboutBrief',
  data(){
    return{
      data: {

      },
      class: {
        1: '公司简介',
        2: '组织架构',
        3: '招贤纳士',
        4: '企业资质',
        5: '企业荣誉',
        6: '管理团队',
        7: '企业文化',
        8: '公司动态',
        9: '基层动态',
        10: '公示公告',
        11: '国家政策',
        12: '地方法规'
      },
      className: ''
    }
  },
  mounted: function(){
    var _this = this

    var urlId = _this.$router.history.current.query.id
    _this.getDetail(urlId)
  },
  methods: {
    async getDetail(id){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/project/getProjectInfoDetail',{id: id});
      if(data.code == 200){
        _this.data = data.data
        _this.className = _this.class[data.data.classification]
      }
    }

  }
}
</script>